import "offline-js";
import store from '../store/store'

export default {
  activate: () => {
    let baseUrl = new URL(store.state.baseUrl)
    console.log('activating offline check', baseUrl.origin)
    Offline.options = {
      checks: {
        xhr: {
          url: baseUrl.origin,
        },
      },
      checkOnLoad: true,
      interceptRequests: true,
    };

    Offline.check()

    setInterval(() => {
      Offline.check()
    }, 5000)

    Offline.on('confirmed-down', () => {
      store.state.OFFLINE = true
    })

    Offline.on('up', () => {
      store.state.OFFLINE = false
    })
  },
}
